import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/**
 * AdminRoute — nests inside ProtectedRoute to further restrict a route to
 * admin accounts. Right now this only guards /docs: the internal
 * wireframes/specs are for the client + dev team's admin users, not
 * every regular account. Non-admins are bounced to /chat rather than
 * shown any error — the Docs nav link is also hidden for them in
 * Navbar.jsx so this should only ever trigger from a typed/bookmarked URL.
 *
 * Note: this only gates the React route. The underlying static files
 * (frontend-web/public/docs/*.html) are still served by whatever hosts
 * the built frontend, same as any other file in public/ — real
 * enforcement against a direct URL guess would require serving them
 * through an authenticated backend route instead.
 */
const AdminRoute = () => {
  const { user } = useAuth();
  if (user?.role !== 'admin') return <Navigate to="/chat" replace />;
  return <Outlet />;
};

export default AdminRoute;
